import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from '@citi-gcg-173875/citi-utils';

@Directive({
  selector: '[mktRouterLink]',
  standalone:false
})
export class MktRouterLinkDirective {
  private _mktRouterLink: string;

  @Input('mktRouterLink')
  set mktRouterLink(val) {
    this._mktRouterLink = val || '';

    // Set HREF so the broswer handles like a normal link
    // This will be overridden in onclick
    if (this.el?.nativeElement) { this.el.nativeElement.href = this._mktRouterLink; }
  }
  get mktRouterLink() {
    return this._mktRouterLink;
  }

  constructor(
    private el: ElementRef,
    private router: Router,
    private _cookieService: CookieService
  ) { }

  @HostListener('click', ['$event'])
  onClick(event) {

    // Prevent standard click action for link
    event.preventDefault();

    //No links
    if (!this.mktRouterLink) {
      return false;
    }

    // Split url
    const origin = window.location.origin || 'https://www.citi.com';
    const urlArray = new URL(this.mktRouterLink, origin);
    const path = urlArray.pathname;
    const searchString = urlArray.search;

    // If path is not relative, then use default link behaviour
    const isDDMKT = path.includes('credit-cards');
    const isLegacy = path.includes('citi.action');
    const redesignPage = this._cookieService.getCookie('vacReDesignvac') ||
                         this._cookieService.getCookie('vacReDesignmpp') ||
                        this._cookieService.getCookie('vacReDesignexplore');
    if (!isDDMKT || isLegacy || redesignPage) {
      event.preventDefault();
      const target = event.currentTarget.getAttribute("target") || '_self';
      window.open(this.mktRouterLink,target,'noopener');
      return true;
    }


    const searchParams = Object.fromEntries(<any>new URLSearchParams(searchString));

    // Get Path Array
    const pathArray = this.splitPath(path.replace('credit-cards',''));

    // Navigate the new path with potential searchParams (main function of routerLink)
    // window.open(this.mktRouterLink, '_self');
    this.router.navigate(pathArray, { queryParams: searchParams });
  }

  private splitPath(path: string = '/') {
    // Split path into an array and remove empty strings
    const pathArray = path.split('/').filter(str => str);

    // Return array with a fallback of '/'
    return pathArray.length > 0 ? pathArray : ['/'];
  }
}
